module.exports = __webpack_public_path__ + "static/media/blackfairy.73d1d075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blackfairy.jpg
// module id = 596
// module chunks = 0